import React from 'react';
import PicButton from '../../../../../../../../../../../../../../components/pic-button/index';

function EmailContactButton (props) {

	const {
		disabled,
		title,
		contactEmail
	} = props;

	const handleClick = (e) => {
		e.stopPropagation();

		if(contactEmail){
			window.open("mailto:" + contactEmail);
		}
	};

	return (
		<PicButton disabled={disabled} onClick={handleClick} title={title || ''}>
			<svg
				width={24}
				height={24}
				viewBox="0 0 24 24"
			>
				<path fill="currentColor" d="M20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm-.8 2L12 10.8 4.8 6h14.4zM4 18V7.87l8 5.33 8-5.33V18H4z" />
			</svg>
		</PicButton>
	)

}

export default EmailContactButton;
